module.exports = __webpack_public_path__ + "static/media/dmt.76b5a3f3.svg";